import { EHEX_ADDRESS } from 'libs/ethereum/constants'

const COW_SWAP_ORIGIN = 'https://swap.cow.fi'

/** Chains CoW Swap currently supports. PulseChain is not among them. */
export const COW_SWAP_CHAIN_IDS = new Set([
  1, // Ethereum
  100, // Gnosis
  137, // Polygon
  8453, // Base
  42161, // Arbitrum
  43114, // Avalanche
  56, // BNB
  59144, // Linea
  11155111, // Sepolia
])

export const cowSwapSrc = (chainId: number, theme: 'light' | 'dark') => {
  if (chainId === 1) {
    return `${COW_SWAP_ORIGIN}/#/1/swap/USDC/${EHEX_ADDRESS}?theme=${theme}`
  }
  return `${COW_SWAP_ORIGIN}/#/${chainId}/swap?theme=${theme}`
}

export const CowSwapEmbed = ({ chainId, theme }: { chainId: number; theme: 'light' | 'dark' }) => {
  const src = cowSwapSrc(chainId, theme)
  return (
    <iframe
      key={src}
      title="CoW Swap"
      src={src}
      height="720px"
      width="100%"
      allow="clipboard-write"
      style={{
        border: 0,
        margin: 0,
        marginBottom: '0.5rem',
        display: 'block',
        maxWidth: '960px',
        overflow: 'hidden',
      }}
    />
  )
}
